export const EVENT_COST_CENTER_SELECTED='EVENT_COST_CENTER_SELECTED'
export const EVENT_CURRENT_SERVICE_SELECTED='EVENT_CURRENT_SERVICE_SELECTED'
export const EVENT_CURRENT_SERVICELINE_SELECTED='EVENT_CURRENT_SERVICELINE_SELECTED'
export const EVENT_CURRENT_GRITEM_SELECTED='EVENT_CURRENT_GRITEM_SELECTED'
export const EVENT_GET_PO_GRITEM_ORIGINAL='EVENT_GET_PO_GRITEM_ORIGINAL'
export const EVENT_GET_PO_SERVICE_ORIGINAL='EVENT_GET_PO_SERVICE_ORIGINAL'
export const EVENT_GET_PO_RELEASE_ORDER='EVENT_GET_PO_RELEASE_ORDER'
export const EVENT_GET_DETAIL_BOT_LOG='EVENT_GET_DETAIL_BOT_LOG'

